import { asFunction, getResult } from "../../helpers/functional-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

const emptyRenderer = () => () => {};

/**
 * `actionButton` renders a button with icon for the righthand action menu.
 *
 * @param {Renderable} label - Label of the button
 * @param {Renderable} loadingLabel - Label of the button when loading
 * @param {icon} [icon] - icon element
 * @param {function} [click] - Callback executed on button click
 * @param {boolean|function} [isDisabled=false] - Disables click and mark button as disabled in UI
 * @param {boolean|function} [isPrimary=false] - Mark button as primary button in UI
 * @param {string} [dataTestName] - A string to be used to find the button with the test framework
 */
export default class ActionButtonWidget extends Widget {
	constructor({
		label,
		loadingLabel,
		icon = emptyRenderer,
		click,
		isDisabled = false,
		isPrimary = false,
		dataTestName,
	}) {
		super(...arguments);

		this._label = label;
		this._loadingLabel = loadingLabel;
		this._icon = icon;
		this._isDisabled = asFunction(isDisabled);
		this._isPrimary = isPrimary;
		this._dataTestName = dataTestName;
		this._loading = false;

		this.onClick = this._events.createEvent();

		if (click) {
			this.onClick.register(click);
		}

		// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
		this._spinnerWidget = new OldSpinnerWidget({
			size: 18,
		});
	}

	setLoading(isLoading) {
		this._loading = isLoading;
		this.update();
	}

	renderContentOn(html) {
		const button = html.a(
			{
				"data-test": this._dataTestName,
				click: () => this._triggerClickEvent(),
				klass: this._getButtonCssClass(),
			},
			this._icon({ class: "action-icon" }),
			this._loading
				? [this._loadingLabel, this._spinnerWidget]
				: this._label,
		);

		if (this._loading) {
			button.setAttribute("disabled", true);
		}
	}

	_getButtonCssClass() {
		const typeOfButton = getResult(this._isPrimary)
			? "btn-primary"
			: "btn-default";

		const buttonState = this._isDisabled() ? "disabled" : "";

		return `btn btn-block ${typeOfButton} ${buttonState}`;
	}

	_triggerClickEvent() {
		if (this._isDisabled()) {
			return;
		}
		this.onClick.trigger();
	}
}
